import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { capitalizeFirstLetter } from "../../helpers/format";
import { FormHelperText } from "@mui/material";

export default function Dropdown({
  value,
  options,
  handleChange,
  label,
  helperText,
  name,
  enableDefault = false,
  touched,
  error,
  handleBlur,
  disabled=false,
  minWidth=120
}: any) {
  
  return (
    // @ts-ignore
    <Box style={{ minWidth }}>
      <FormControl fullWidth>
        {label && (
          <InputLabel id="demo-simple-select-label">{label}</InputLabel>
        )}
        <Select
          disabled={disabled}
          value={value || value === false ? value : ""}
          label={label ? label : ""}
          name={name}
          onChange={handleChange}
          placeholder="Select a value"
          error={(error && touched) as boolean}
          onBlur={handleBlur}
        >
          <MenuItem disabled={!enableDefault} value="">
            <em>Add value</em>
          </MenuItem>
          {options.map((item: any) => (
            <MenuItem value={item.key} key={item.label}>
              {item.label}
            </MenuItem>
          ))}
        </Select>
        {helperText && !error && (
          <FormHelperText>{helperText}</FormHelperText>
        )}
        {/* {touched && error && (
          <FormHelperText error>
            {capitalizeFirstLetter(error)}
          </FormHelperText>
        )} */}
      </FormControl>
      {touched && error && (
        <p className="text-red-600 text-sm mb-2">
          {capitalizeFirstLetter(error)}
        </p>
      )}
    </Box>
  );
}
